module.exports = __webpack_public_path__ + "img/20f1.4dbb298f.jpg";